/**
 * 新版机器人
 */
import WenwenBot from '@ad/imbot-sdk'
import Feelgood from '@ad/feelgood-sdk'
import { botConfig, defaultSurveyConfig, reportStartQuestionList } from './config'
import { initAthenaSurvey } from './feelgood-sdk.js'
import { isAdV2 } from 'Src/util/tool'
export const initImbot = (config = {
  hideFeelgood: false,
  feelgood: {},
  botConfig: {}
}) => {
  if (!WenwenBot) {
    return
  }
  if (!config.hideFeelgood) {
    initAthenaSurvey(Object.assign({}, defaultSurveyConfig, {
      ...config.feelgood
    }))
  }
  let botCon = Object.assign({}, botConfig, {
    ...config.botConfig,
    // 展示窗口时的回调，一般用来隐藏 Feelgood
    onShow () {
      Feelgood.setAllExpand(false)
      if (window.AthenaSurvey) {
        window.AthenaSurvey.setAllExpand(false)
      }
      // 埋点
      if (window.teaEvent) {
        window.teaEvent('feedback_click_service_button', {
          url: window.location.href,
          page: window.location.hostname.split('.')[0]
        })
      }
    },
    // 点击意见反馈时的回调，用于唤起 Feelgood
    onFeedback (type) {
      if (window.AthenaSurvey) {
        window.AthenaSurvey.triggerSurvey(window.AthenaSurveyId || '6769094744803901454')
      }
      // 埋点
      if (window.teaEvent) {
        window.teaEvent('feedback_click_feedback_button', {
          type: type === 'message' ? 1 : 2,
          url: window.location.href,
          page: window.location.hostname.split('.')[0]
        })
      }
    }
  })
  // 初始化智能客服
  WenwenBot.init(botCon)
  window.WenwenBot = WenwenBot
}

// 创建计划 & 创意的时候，发送feelgood
export const isHaveValidTaskId = async (params, cb) => {
  const athenaSurvey = window.AthenaSurvey || Feelgood
  const taskId = await athenaSurvey.triggerEvent(params.eventKey || 'create-done', {
    immediate: false
  })
  cb && cb(taskId)
}

// 创建计划 & 创意的时候，发送feelgood
export const openTriggerSurvey = async (taskId, params, cb, type = '', buttonPosition) => {
  const athenaSurvey = window.AthenaSurvey || Feelgood
  let isBack = false
  // 3. 当被调查对象同意参与调研时（点击确定按钮），调用feelgood sdk 弹出弹窗
  const survey = await athenaSurvey.triggerSurvey(taskId, {
    ignoreCheck: true,
    userInfo: Object.assign({}, params, window.AthenaSurveyUserInfo || {}, {
      slardar_session_id: window.Slardar?.shared?.config?.commonParams?.slardar_session_id || ''
    }),
    shellPosition: buttonPosition || {}
  })
  // 4. 在反馈提交时，读取其选择的选项
  survey.$on('submit-completed', (detail) => {
    isBack = true
    const data = type === 'feelgood' ? detail.params.data : null // detail.params.data = 用户填写的表单内容
    setTimeout(() => {
      cb && cb(data)
    }, 100)
  })
  // 用户点击【不再显示】
  survey.$on('refuse', () => {
    setTimeout(() => {
      cb && cb()
    }, 100)
  })

  // 用户关闭弹窗
  survey.$on('close', () => {
    if (!isBack) {
      setTimeout(() => {
        cb && cb()
      }, 100)
    }
  })
}

// 根据报表路径和hash给出问问上报参数
export const getReportStartQuestion = (originHash) => {
  /**
   * 过滤非ad报表页面
   * pages/reporter/ 为ad报表包含的路径
  */
  const isReporter = window.location.pathname.search('pages/reporter/') !== -1
  // 非报表页面返回undefined
  if (!isReporter) {
    return undefined
  }
  // 对hash处理, 将字母之外的字符转换为'_'方便处理对象
  const hash = originHash.slice(2)
  const key = hash.replace(/[^a-zA-Z^_]/g, '_')
  // 添加路径,
  reportStartQuestionList[key] && (reportStartQuestionList[key].sourcePage = window.location.origin + window.location.pathname + window.location.hash)
  return reportStartQuestionList[key]
}

// 根据页面路径，判断渠道
export const getAppChannel = () => {
  const url = window.location.pathname
  const isV2Str = isAdV2() ? '_2.0' : ''
  switch (true) {
    // 资产和工具 穿山甲自定义媒体包
    case url.search('pages/toolbox/self') !== -1 || url.search('overview.html') !== -1:
      return 'ad_sssets_meitibao' + isV2Str
    // rta策略管理
    case url.search('rta_management.html') !== -1:
      return 'ad_tools_rta' + isV2Str
    // 在投计划配额
    case url.search('quota.html') !== -1:
      return 'ad_adv_peie' + isV2Str
    // 报表页面
    case url.search('pages/reporter/') !== -1:
      return 'ad_report' + isV2Str
    default:
      return 'ad_home'
  }
}
